import React, { FC } from 'react';

import { RemoteComponent } from '@adsk/exo-skeleton-react';

export type RemoteNetworkOnboardingACCUserModalProps = {
  showModal: boolean;
  onSuccess: () => void; // callback when a user successfully on-boards
};

const RemoteNetworkOnboardingACCUserModal: FC<
  RemoteNetworkOnboardingACCUserModalProps
> = ({ ...props }) => (
  <RemoteComponent
    scope="accNetworkApiComponents"
    moduleName="./OnboardingACCUserModal"
    {...props}
  />
);

export default RemoteNetworkOnboardingACCUserModal;
